const AMOUNT_PER_VIEW = 3;

export default AMOUNT_PER_VIEW;
